import { Resource } from 'utoniq-ui'

import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { FavoriteMemberCreateForm, Props } from './FavoriteMemberCreateForm'

export type State = {
  creatingMember: boolean
  artistId: string
  progress: number
}

export type Action = {
  onDrop: () => Promise<Resource | null>
  onSubmit: Props['onSubmit']
}

export const ConsoleFavoriteMemberCreateTemplate: Template<State, Action> = ({
  state,
  onDrop,
  onSubmit,
}) => {
  const { routerPages } = useRouter()
  const { t } = useTranslation('consoleFavoriteMemberCreate')

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <ConsoleBaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleFavoriteMemberSettings,
          title: t('title'),
        }}
      >
        <FavoriteMemberCreateForm
          onSubmit={onSubmit}
          progress={state.progress}
          onDrop={onDrop}
          isSubmitting={state.creatingMember}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
